import axios from "axios";
import { useEffect, useState } from "react";
import { ANAHEX_BE_HOST_NAME } from "../../../../../helpers/hostname.provider.js";

const API_HOST_NAME = ANAHEX_BE_HOST_NAME

const PhoneValidationCard = ({ pos, leaving, onNext, currentUser, onOTPReceive, setUser, onOTPSend }) => {
    const { name, whatsappNumber, institution, designation, linkedinUrl, googleUser } = currentUser || {};

    const [otp, setOTP] = useState();
    const [isLoading, setLoading] = useState();
    const [error, setError] = useState();

    async function register(accessToken) {
        const response = await axios.post(
            `${API_HOST_NAME}/user/signup/register`,
            {
                whatsappNumber,
                designation,
                institution,
                linkedinUrl,
                authData: {
                    authProviderID: 'google.com',
                    authToken: accessToken
                }
            },
            {
                validateStatus: () => true // 👈 never throw for HTTP status
            }
        );

        return {
            status: response.status,
            data: response.data
        };
    }

    const onClick = async () => {
        if (!(/^[0-9]{6,9}$/.test(otp))) {
            setError("Invalid OTP. Please check.");
            return;
        }

        if (isLoading) return;

        setLoading(true);
        setError(null);

        try {
            const accessToken = await onOTPReceive(otp, googleUser);
            if (accessToken) {
                const response = await register(accessToken);
                if (response.data?.successCode === 'VERIFIED')
                    onNext();
            }
        } catch (err) {
            setError("Something went wrong. Please retry.");
        } finally {
            setLoading(false);
        }
    };

    const isAllowed = /^[0-9]{6,9}$/.test(otp);

    return <div className={`content-card card-${pos} ${leaving ? "leaving" : ""}`}>
        <div className="phone-validation-card-subtitle">
            Please Verify
        </div>
        <div className="phone-validation-card-description">
            Enter the SMS OTP we sent to your Phone to finish setting up your account.
        </div>
        <div className="phone-validation-input-card">
            <label className="phone-validation-input-title" htmlFor="fromInput">SMS OTP*</label>
            <input
                id="fromInput"
                className="phone-validation-input-field"
                type="text"
                disabled={pos !== 1}
                onChange={(e) => setOTP(e.target.value)}
            />
        </div>

        <div className={`next-button ${isAllowed ? 'allowed' : ''} ${isLoading ? 'loading' : ''}`}
            onClick={isAllowed && !isLoading ? onClick : null}>Validate OTP</div>

        <ResendOTP currentUser={currentUser} onOTPSend={async () => {
            const status = await onOTPSend("phone-recaptcha-container", googleUser)
            if (status?.status && status?.accessToken && status?.alreadyLinked) {
                const response = await register(status.accessToken);
                if (response.data?.successCode === 'VERIFIED')
                    onNext();
            }
        }} onNext={onNext} />
        <div id="phone-recaptcha-container"></div>
        <div className="phone-validation-error-message">{
            otp && !isAllowed ? 'Invalid OTP' : error}</div>
    </div>
}


function formatName(name) {
    if (!name) return "";

    const firstWord = name.trim().split(/\s+/)[0];
    const capped =
        firstWord.charAt(0).toUpperCase() + firstWord.slice(1);

    return capped.slice(0, 20);
}

const ResendOTP = ({ onOTPSend }) => {
    const [disabled, setDisabled] = useState(true);
    const [timer, setTimer] = useState(30);

    useEffect(() => {
        if (!disabled) return;

        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setDisabled(false);
                    return 30;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [disabled]);

    const handleClick = async () => {
        if (disabled) return;

        setDisabled(true);
        setTimer(30);

        await onOTPSend()
    };

    return (
        <div
            onClick={handleClick}
            className={`resend-otp ${disabled ? 'disabled' : ''}`}
        >
            {disabled ? `Resend OTP in ${timer}s` : "Resend OTP"}
        </div>
    );
};



export default PhoneValidationCard;